import { fetchMobileHomepage } from "../../apiCalls/urls/urlFunction";
import * as actionTypes from "./actionTypes";

export function onHomepageData() {
  return async (dispatch) => {
      const mobileHomepageResponse = await fetchMobileHomepage();

    if (mobileHomepageResponse?.status) {
      dispatch(updateHomepageReducer(mobileHomepageResponse?.data));
    } else {
      console.error(mobileHomepageResponse?.error);
    } 
  };
}

export const updateHomepageReducer = (payload) => {
  return {
      type: actionTypes.UPDATE_MOBILE_HOMEPAGE_DATA,
    payload
  };
};
